import type { QuoteHeadingNames } from "@workspace/api-zod/quote-headings";
import { getEffectiveSubGroup, type PlacementItem } from "./section-placement";

/** Category badges retain their existing wording unless this item's built-in
 * subgroup has an explicit alias. No classification or grouping is changed. */
export function quoteCategoryLabel(names: QuoteHeadingNames | null | undefined, item: PlacementItem, fallback: string): string {
  const subgroup = getEffectiveSubGroup(item);
  return (subgroup && names?.[`subgroup:${subgroup}`]) || fallback;
}
